export class PlayIcon {
  public playIcon: SVGElement;

  constructor() {
    this.playIcon = this.createPlayIcon();
  }

  private createPlayIcon(): SVGElement {
    const playIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    playIcon.setAttributeNS(null, "id", "playIcon");
    playIcon.setAttributeNS(null, "x", "24px");
    playIcon.setAttributeNS(null, "y", "24px");
    playIcon.setAttributeNS(null, "viewBox", "0 0 24 24");

    const svgGroup = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgGroup?.classList?.add("svgIcon");
    playIcon.appendChild(svgGroup);

    const path1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path1.setAttributeNS(null, "d", "M8 5v14l11-7z");
    svgGroup.appendChild(path1);

    return playIcon;
  }
}
